import React from "react";
import "../Assests/TaskDetailsModal.css";

export default function TaskDetailsModal({ ticket, projectName = "-", onClose }) {
    if (!ticket) return null;

    const createdAt = ticket.created_at
        ? new Date(ticket.created_at).toLocaleString()
        : "-";

    return (
        <div className="tdm-overlay" onClick={onClose}>
            <div className="tdm-modal" onClick={(e) => e.stopPropagation()}>
                <div className="tdm-header">
                    <div>
                        <div className="tdm-title">{ticket.title || "Task Details"}</div>
                        <div className="tdm-subtitle">
                            TASK-{ticket.ticket_id} • {projectName}
                        </div>
                    </div>
                    <button className="tdm-close" onClick={onClose}>×</button>
                </div>

                <div className="tdm-body">
                    <Row label="Description" value={ticket.description || "-"} />
                    <Row label="Assignee To" value={ticket.assignee || "-"} />
                    <Row label="Assignee by" value={ticket.reporter || "-"} />
                    <Row label="Priority" value={ticket.priority || "-"} />
                    {/* <Row label="Status (Ready)" value={ticket.status ? "True" : "False"} /> */}
                    <Row label="Closed" value={ticket.is_closed ? "Yes" : "No"} />
                    <Row label="Type" value={ticket.type || "-"} />
                    <Row label="Module" value={ticket.module || "-"} />
                    <Row label="Story Points" value={ticket.story_points ?? "-"} />
                    <Row label="File Name" value={ticket.file_name || "-"} />
                    <Row label="Created At" value={createdAt} />
                </div>
                

                <div className="tdm-footer">
                    <button className="tdm-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
}

function Row({ label, value }) {
    return (
        <div className="tdm-row">
            <div className="tdm-label">{label}</div>
            <div className="tdm-value" title={String(value)}>{value}</div>
        </div>
    );
}